import Http from './http'

export default {
	index(filter){
    return Http.get('/done_items', {params: {...filter}})
  },
  indexByForm(item_setup_id, filter){
    return Http.get(`/item_setups/${item_setup_id}/done_items`, {params: {...filter}})
  },
  show(id){
    return Http.get(`/done_items/${id}`)
  },

  update(done_item){
    let {photo_compressed, signature_img, ...di} = done_item
    if (photo_compressed && photo_compressed.length && Array.isArray(photo_compressed)) {
      photo_compressed = photo_compressed.filter(pc=> (!pc.id && pc.data) || (typeof(pc)=='string'))
    }
    if (signature_img && signature_img.length) {
      if (signature_img.includes('http')){
        signature_img = null
      }
    }
    let obj = {
      ...di,
      photo_compressed,
    }
    if (signature_img){
      obj = {...obj, signature_img}
    }
    
    return Http.put(`/done_items/${done_item.id}`, {
      done_item: {
        ...obj
      }
    })
  },

  create(done_item){
    let {photo_compressed, signature_img, ...di} = done_item
    if (photo_compressed && photo_compressed.length && Array.isArray(photo_compressed)) {
      photo_compressed = photo_compressed.filter(pc=> !pc.id && pc.data)
    }
    if (signature_img && signature_img.length) {
      if (signature_img.includes('http')){
        signature_img = null
      }
    }
    let obj = {
      ...di,
      photo_compressed,
    }
    if (signature_img){
      obj = {...obj, signature_img}
    }
    
    return Http.post(`/done_items`, {
      done_item: {
        ...obj
      }
    })
  },
}
